import { styled } from 'styled-components';
import THEME from '../theme.js';
const hoverColors = {
    default: {
        background: `${THEME.COLOR_PRIMARY}15`,
        color: THEME.COLOR_PRIMARY,
    },
    danger: { background: `${THEME.DANGEROUS}15`, color: THEME.DANGEROUS },
};
const IconButton = styled.button `
  background: transparent;
  border: none;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  color: ${THEME.COLOR_GREY};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${(p) => hoverColors[p.$variant ?? 'default'].background};
    color: ${(p) => hoverColors[p.$variant ?? 'default'].color};
  }
`;
export default IconButton;
//# sourceMappingURL=IconButton.js.map